module.exports = __webpack_public_path__ + "img/logo_x2.d302ec75.jpg";